import React from 'react';
import { SvgIcon } from '@progress/kendo-react-common';
import { Label } from '@progress/kendo-react-labels';
import { ActionItemId, DropDownButtonItem } from './FilterActions.types';

interface FilterActionsContextMenuProps {
  position: { x: number; y: number } | null;
  items: DropDownButtonItem[];
  onItemClick: (item: DropDownButtonItem) => void;
  onClose: () => void;
}

export const FilterActionsContextMenu: React.FC<FilterActionsContextMenuProps> = ({
  position,
  items,
  onItemClick,
  onClose
}) => {
  if (!position) {
    return null;
  }

  return (
    <>
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 10000
        }}
        onClick={onClose}
        onContextMenu={e => {
          e.preventDefault();
          onClose();
        }}
      />

      <div
        className="k-popup k-menu-popup filterActionButtonPopup"
        style={{
          position: 'fixed',
          left: `${position.x}px`,
          top: `${position.y}px`,
          zIndex: 10001
        }}
      >
        <ul className="k-menu k-menu-vertical filterActionContextMenu">
          {items
            .filter(item => !item.isHidden)
            .map((item, index) => (
              <li
                key={`${item.id}-${item.groupId}-${index}`}
                className="k-menu-item"
                onClick={() => {
                  if (item.id !== ActionItemId.GROUP) {
                    onItemClick(item);
                  }
                }}
              >
                <span className="k-menu-link">
                  <div className={item.className || `filterActionButtonOption`}>
                    {item.svgIcon && <SvgIcon icon={item.svgIcon} />}
                    <Label key={item.id}>{item.text}</Label>
                  </div>
                </span>
              </li>
            ))}
        </ul>
      </div>
    </>
  );
};
